import React from 'react';
import './index.css';

const Tile = props => {
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            props.handleClick();
        }
    }
    const allowResubmissions = props.assignment && props.assignment.allowResubmissions;
    return (
        <div tabIndex={0} className="tile" onClick={props.handleClick} onKeyDown={handleKeyDown}>
            <div className="leftHalf">
                {props.name && <h3>{props.name}</h3>}
                {props.number && <h1>{props.number}</h1>}
                {props.status && allowResubmissions ?  <h3>{props.status}</h3> : null}
            </div>
            <div className="rightHalf">
                {props.dueDate && <div><h2>{props.dueDate}</h2></div>}
                {props.grade && <h4>{props.grade}</h4>}
            </div>
        </div>
    )
}

export default Tile;
